import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useQuiz } from '../../hooks/useQuiz';
import { ConfirmModal } from '../ui/ConfirmModal';
import {
  UserIcon,
  ArrowLeftIcon,
} from '@heroicons/react/24/outline';

export const TopBar: React.FC = () => {
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const { cancelSession } = useQuiz();
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);

  // Rileva se siamo in una sessione quiz attiva
  const isInQuizSession = location.pathname.startsWith('/quiz/');

  const handleExitQuiz = () => {
    // Mostra modale di conferma
    setIsConfirmModalOpen(true);
  };

  const handleConfirmExit = async () => {
    try {
      // Cancella la sessione dal backend
      await cancelSession();
      // Naviga alla dashboard
      navigate('/subjects');
    } catch (error) {
      console.error('Errore durante la cancellazione della sessione:', error);
      // Naviga comunque alla dashboard anche se la cancellazione fallisce
      navigate('/subjects');
    }
  };

  return (
    <header className="bg-white shadow-sm border-b border-gray-200 flex-shrink-0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex items-center">
            <Link to="/" className="flex items-center space-x-3">
              <img 
                src="/logo-live-concorsi.png" 
                alt="Live Concorsi" 
                className="h-10 sm:h-12 md:h-14 lg:h-16 w-auto transition-all duration-300"
              />
            </Link>
          </div>

          {/* Pulsante Esci dal Quiz - Solo quando si è in una sessione quiz */}
          {isInQuizSession && (
            <div className="flex items-center">
              <button
                onClick={handleExitQuiz}
                className="flex items-center space-x-2 px-4 py-2 text-sm font-medium text-white bg-red-500 hover:bg-red-600 rounded-full shadow-sm hover:shadow-md transition-all duration-200 border border-red-400"
              >
                <ArrowLeftIcon className="h-4 w-4" />
                <span className="hidden sm:inline">Esci dal Quiz</span>
                <span className="sm:hidden">Esci</span>
              </button>
            </div>
          )}

          {/* User Info - Solo quando NON si è in quiz */}
          {!isInQuizSession && (
            <div className="flex items-center space-x-3">
              <div className="w-8 h-8 bg-primary-100 rounded-full flex items-center justify-center">
                <UserIcon className="h-5 w-5 text-primary-600" />
              </div>
              <div className="text-sm">
                <p className="font-medium text-gray-900">
                  Benvenuto, {user?.firstName && user?.lastName 
                    ? `${user.firstName} ${user.lastName}` 
                    : user?.email}
                </p>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Modale di conferma per uscire dal quiz */}
      <ConfirmModal
        isOpen={isConfirmModalOpen}
        onClose={() => setIsConfirmModalOpen(false)}
        onConfirm={handleConfirmExit}
        title="Esci dal Quiz"
        message="Sei sicuro di voler uscire dal quiz? Il progresso attuale andrà perso e non potrai più continuare questa sessione."
        confirmText="Esci dal Quiz"
        cancelText="Continua Quiz"
        type="danger"
      />
    </header>
  );
};
